export const env = {
  API_BASE_URL: window.__ENV__.VUE_APP_API_BASE_URL,
  API_BASE_V3: window.__ENV__.VUE_APP_API_BASE_V3,
  MES_THUN_URL: window.__ENV__.VUE_APP_MES_THUN_URL,
};
